import { render, staticRenderFns } from "./Challans.vue?vue&type=template&id=6e71ad1c"
import script from "./Challans.vue?vue&type=script&lang=js"
export * from "./Challans.vue?vue&type=script&lang=js"
import style0 from "./Challans.vue?vue&type=style&index=0&id=6e71ad1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports